import i18n from 'i18next';

export default (bool) => {
  if (bool === true) return i18n.t('msg_codes_common_yes');
  return i18n.t('msg_codes_cta_no');
};
